'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

export function RouteMarker() {
  const pathname = usePathname()

  useEffect(() => {
    document.documentElement.dataset.route = pathname
  }, [pathname])

  return null
}